import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { Logo } from "./Logo";

export class LogoComponent extends AbstractDisplayComponent {
    public container: Logo;

    public override init() {
        let containerConfig = {
            labelName: "logo_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 290,
                posY: 725,
                scale: 0.8,
            },
            portrait: {
                posX: 780,
                posY: 250,
                scale: 1,
            }
        };

        this.container = new Logo(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public resize(check: boolean){
        this.container.setLogoPositionResize(check);
    }

}
